import React from 'react';
import { PhoneCallsContext } from './phone-calls-context';
import { PhoneCallsStore } from './phone-calls-store';

export function usePhoneCallsStore(): PhoneCallsStore {
    const value = React.useContext(PhoneCallsContext);
    if (!value) throw new Error('Unexpectedly did not find phone calls store on context');
    return value;
}
